import * as S from "./DesktopDivider.style";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

const DesktopDivider = () => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }
  return <S.DesktopDivider />;
};

export default DesktopDivider;
